import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  themeMode: 'light', // Default to light mode
  isLoading: false,
  error: null,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeMode: (state, action) => {
      state.themeMode = action.payload;
    },
    toggleTheme: (state) => {
      state.themeMode = state.themeMode === 'light' ? 'dark' : 'light';
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setThemeMode,
  toggleTheme,
  setLoading,
  setError,
  clearError,
} = themeSlice.actions;

// Selectors
export const selectThemeMode = (state) => state.theme.themeMode;
export const selectIsDarkMode = (state) => state.theme.themeMode === 'dark';
export const selectIsLightMode = (state) => state.theme.themeMode === 'light';
export const selectThemeLoading = (state) => state.theme.isLoading;
export const selectThemeError = (state) => state.theme.error;

export default themeSlice.reducer;






















